import firebase from 'firebase/app'

import { HTTP_API_V2 } from '../../http-common'

export default {
  state: {
    loadedDevices: [],
    loadedDevicesV2: [],
    selectedDevice: null,
    selectedDeviceV2: null
  },
  getters: {
    loadedDevices (state) {
      return state.loadedDevices
    },
    loadedDevicesV2 (state) {
      return state.loadedDevicesV2
    },
    loadedDevice (state) {
      return (deviceId) => {
        return state.loadedDevices.find(device => {
          return device.id === deviceId
        })
      }
    },
    loadedDeviceV2 (state) {
      return (deviceId) => {
        return state.loadedDevicesV2.find(device => {
          return device.id === deviceId
        })
      }
    },
    selectedDevice (state) {
      return state.selectedDevice
    },
    selectedDeviceV2 (state) {
      return state.selectedDeviceV2
    }
  },
  // synchronous
  mutations: {
    setLoadedDevices (state, payload) {
      state.loadedDevices = payload
    },
    setLoadedDevicesV2 (state, payload) {
      state.loadedDevicesV2 = payload
    },
    createDevice (state, payload) {
      state.loadedDevices.push(payload)
    },
    updateDevice (state, payload) {
      const device = state.loadedDevices.find(device => {
        return device.id === payload.id
      })
      if (device) {
        if ('description' in payload) {
          device.description = payload.description
        }
        if ('mac' in payload) {
          device.mac = payload.mac
          if (payload.mac !== device.id) {
            device.id = payload.mac
          }
        }
        if ('type' in payload) {
          device.type = payload.type
        }
      }
    },
    setForAllDevices (state, payload) {
      const devices = state.loadedDevices.map(device => {
        let _device = device
        _device.alarmRules = payload.alarmRules
        return _device
      })
      state.loadedDevices = devices
    },
    removeDevice (state, payload) {
      let devices = state.loadedDevices.filter((device) => {
        return device.id !== payload.id
      })
      state.loadedDevices = devices
    }
  },
  // asynchronous
  actions: {
    loadDevices ({ commit }) {
      commit('clearError')
      commit('setLoading', true)
      const userId = firebase.auth().currentUser.uid
      firebase.database().ref(userId + '/devices').once('value')
        .then(data => {
          let _devices = []
          const obj = data.val()
          for (let key in obj) {
            _devices.push({
              id: key,
              createdAt: obj[key].createdAt,
              description: obj[key].description,
              lastAccess: obj[key].lastAccess,
              mac: obj[key].mac,
              type: obj[key].type,
              createdById: obj[key].createdById,
              createdByEmail: obj[key].createdByEmail,
              fieldsToShow: obj[key].fieldsToShow,
              alarmRules: obj[key].alarmRules
            })
          }
          let devices = _devices.sort((a, b) => {
            if (a.createdAt < b.createdAt) return -1
            if (a.createdAt > b.createdAt) return 1
            return 0
          })
          commit('setLoadedDevices', devices)
        })
        .catch(err => {
          console.log(err)
          commit('setError', err.message)
        })
        .finally(() => {
          commit('setLoading', false)
        })
    },
    loadDevicesV2 ({ commit }) {
      commit('clearError')
      commit('setLoading', true)
      commit('setLoadedDevicesV2', [])
      return new Promise((resolve, reject) => {
        HTTP_API_V2.get('devices')
        .then(result => {
          const retroCompatibleResult = result.data
            .map(device => {
              return {
                id: device.id,
                description: device.description,
                type: device.model,
                mac: device.identifier_value,
                barn: device.barn,
                base: device.base,
                permissions: device.permissions,
                created_at: device.created_at,
                token: device.token,
                device_model: device.device_model
              }
            })
          commit('setLoadedDevicesV2', retroCompatibleResult)
          resolve(retroCompatibleResult)
        })
        .catch(err => {
          console.log(err)
          commit('setError', err.message)
        })
        .finally(() => {
          commit('setLoading', false)
        })
      })
    },
    // createDevice ({ commit, getters }, payload) {
    //   commit('clearError')
    //   commit('setLoading', true)
    //   const newDevice = {
    //     createdAt: firebase.database.ServerValue.TIMESTAMP,
    //     description: payload.description,
    //     lastAccess: payload.lastAccess,
    //     mac: payload.mac,
    //     type: payload.type,
    //     createdById: getters.user.id,
    //     createdByEmail: getters.user.email,
    //     alarmRules: {
    //       0: {
    //         alarmLevel: 2,
    //         maxHumidity: 2.0,
    //         maxTemperature: 2.0,
    //         minHumidity: 2.0,
    //         minTemperature: 2.0,
    //         maxPressure: 2.0,
    //         minPressure: 2.0,
    //         maxWaterConsumption: 2.0,
    //         minWaterConsumption: 2.0,
    //         maxSilo1Consumption: 2.0,
    //         minSilo1Consumption: 2.0,
    //         maxSilo2Consumption: 2.0,
    //         minSilo2Consumption: 2.0,
    //         enabledTemperature: true,
    //         enabledHumidity: true,
    //         enabledPressure: true,
    //         enabledWaterConsumption: true,
    //         enabledSilo1Consumption: true,
    //         enabledSilo2Consumption: true
    //       },
    //       1: {
    //         alarmLevel: 1,
    //         maxHumidity: 1.0,
    //         maxTemperature: 1.0,
    //         minHumidity: 1.0,
    //         minTemperature: 1.0,
    //         maxPressure: 1.0,
    //         minPressure: 1.0,
    //         maxWaterConsumption: 1.0,
    //         minWaterConsumption: 1.0,
    //         maxSilo1Consumption: 1.0,
    //         minSilo1Consumption: 1.0,
    //         maxSilo2Consumption: 1.0,
    //         minSilo2Consumption: 1.0,
    //         enabledTemperature: true,
    //         enabledHumidity: true,
    //         enabledPressure: true,
    //         enabledWaterConsumption: true,
    //         enabledSilo1Consumption: true,
    //         enabledSilo2Consumption: true
    //       }
    //     },
    //     fieldsToShow: {
    //       temperature: true,
    //       humidity: true,
    //       pressure: true,
    //       water: true,
    //       silo1: true,
    //       silo2: true
    //     }
    //   }
    //   const userId = firebase.auth().currentUser.uid
    //   return firebase.database().ref(userId + '/devices/' + newDevice.mac.toLowerCase()).set(newDevice)
    //     .then(data => {
    //       console.log(data)
    //       commit('createDevice', {
    //         ...newDevice,
    //         id: newDevice.mac
    //       })
    //     })
    //     .catch(err => {
    //       console.log(err)
    //       commit('setError', err.message)
    //     })
    //     .finally(() => {
    //       commit('setLoading', false)
    //     })
    // },
    async updateDevice ({ commit }, payload) {
      commit('clearError')
      commit('setLoading', true)
      let updateObj = {}
      if ('description' in payload) {
        updateObj.description = payload.description
      }
      if ('mac' in payload) {
        updateObj.mac = payload.mac
      }
      if ('type' in payload) {
        updateObj.type = payload.type
      }
      if ('fieldsToShow' in payload) {
        updateObj.fieldsToShow = payload.fieldsToShow
      }
      if ('alarmRules' in payload) {
        updateObj.alarmRules = payload.alarmRules
      }
      const userId = firebase.auth().currentUser.uid
      // console.log('userId:', userId)
      // console.log('payload.id:', payload.id)

      if (updateObj.mac && (updateObj.mac !== payload.id)) {
        try {
          const snapshot = await firebase.database().ref(userId + '/devices').child(payload.id).once('value')
          await firebase.database().ref(userId + '/devices/' + updateObj.mac.toLowerCase()).set(snapshot.val())
          await firebase.database().ref(userId + '/devices').child(payload.id).remove()
        } catch (err) {
          console.log(err)
        }
      }

      return firebase.database().ref(userId + '/devices').child(payload.id).update(updateObj)
        .then(() => {
          commit('updateDevice', payload)
        })
        .catch(err => {
          console.log(err)
          commit('setError', err.message)
        })
        .finally(() => {
          commit('setLoading', false)
        })
    },
    setForAllDevices ({ commit }, payload) {
      commit('setForAllDevices', payload)
    },
    removeDevice ({ commit }, payload) {
      const userId = firebase.auth().currentUser.uid
      return firebase.database().ref(userId + '/devices').child(payload.id).remove()
        .then(() => {
          commit('removeDevice', payload)
        })
        .catch(err => {
          console.log(err)
        })
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/device/index.js